import { render } from "./partnerList2.vue?vue&type=template&id=45dd85ca&scoped=true"
import script from "./partnerList2.vue?vue&type=script&lang=js"
export * from "./partnerList2.vue?vue&type=script&lang=js"

import "./partnerList2.vue?vue&type=style&index=0&id=45dd85ca&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&id=45dd85ca&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dd85ca"]])

export default __exports__